/**
 * @generated SignedSource<<db748fe0bb8caa1ea4986b11d2c76dbc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type calendarCardKey_calendar$data = {
  readonly key: string;
  readonly " $fragmentType": "calendarCardKey_calendar";
};
export type calendarCardKey_calendar$key = {
  readonly " $data"?: calendarCardKey_calendar$data;
  readonly " $fragmentSpreads": FragmentRefs<"calendarCardKey_calendar">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "calendarCardKey_calendar",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "900ec6b745053c5ea712c316af054be0";

export default node;
